export class CloudGridError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'CloudGridError';
  }
}

export function die(msg: string): never {
  throw new CloudGridError(msg);
}
